import { render } from "./ManageNotifications.vue?vue&type=template&id=56a6fc67&scoped=true"
import script from "./ManageNotifications.vue?vue&type=script&lang=js"
export * from "./ManageNotifications.vue?vue&type=script&lang=js"

import "./ManageNotifications.vue?vue&type=style&index=0&id=56a6fc67&scoped=true&lang=css"

import exportComponent from "/home/saes/central_authentication/central_authentication_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a6fc67"]])

export default __exports__